import { BrowserRouter, HashRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/index.css";
import { AppLayout } from "./components/layout/AppLayout";
import { BrainstormProvider } from "./context/BrainstormContext";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import { SofiaAssistant } from "./components/SofiaAssistant";

// Use HashRouter in Electron (file:// protocol) to avoid blank pages on route refresh
const Router = window.electronAPI?.isElectron ? HashRouter : BrowserRouter;

// Pages
import LaunchScreen from "./pages/LaunchScreen";
import ContentStrategist from "./pages/ContentStrategist";
import ContentCalendar from "./pages/ContentCalendar";
import ContentPreviewBoard from "./pages/ContentPreviewBoard";
import BlogPublisher from "./pages/BlogPublisher";
import CompetitiveIntel from "./pages/CompetitiveIntel";
import PerformanceIntelligence from "./pages/PerformanceIntelligence";
import WebsiteConverter from "./pages/WebsiteConverter";
import WeeklyNewsletter from "./pages/WeeklyNewsletter";
import SocialVideoCreator from "./pages/SocialVideoCreator";
import AdVideoAgent from "./pages/AdVideoAgent";
import Settings from "./pages/Settings";
import Dashboard from "./pages/Dashboard";
import BrandManager from "./pages/BrandManager";
import InfluencerTracker from "./pages/InfluencerTracker";
import AutoStrategy from "./pages/AutoStrategy";
import TrendingTopics from "./pages/TrendingTopics";
import ReviewDashboard from "./pages/ReviewDashboard";
import SchedulerBoard from "./pages/SchedulerBoard";
import ContentStudio from "./pages/ContentStudio";
import LoginPage from "./pages/LoginPage";
import ContentPlanReview from "./pages/ContentPlanReview";
import NewsletterSubscribers from "./pages/NewsletterSubscribers";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import PublishingHub from "./pages/PublishingHub";
import ContentRepurposer from "./pages/ContentRepurposer";
// Labs
import BrainstormLab from "./pages/BrainstormLab";
import ResearchLab from "./pages/ResearchLab";

function AppRoutes() {
  const { user, loading, login } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#060610' }}>
        <div className="w-8 h-8 rounded-xl animate-pulse" style={{ background: 'rgba(124,94,250,0.3)' }} />
      </div>
    );
  }

  if (!user) {
    return <LoginPage onLogin={login} />;
  }

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<LaunchScreen />} />
        <Route path="/strategist" element={<ContentStrategist />} />
        <Route path="/calendar" element={<ContentCalendar />} />
        <Route path="/board" element={<ContentPreviewBoard />} />
        <Route path="/blog" element={<BlogPublisher />} />
        <Route path="/intel" element={<CompetitiveIntel />} />
        <Route path="/performance" element={<PerformanceIntelligence />} />
        <Route path="/converter" element={<WebsiteConverter />} />
        <Route path="/newsletter" element={<WeeklyNewsletter />} />
        <Route path="/video" element={<SocialVideoCreator />} />
        <Route path="/advideo" element={<AdVideoAgent />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/brands" element={<BrandManager />} />
        <Route path="/influencer" element={<InfluencerTracker />} />
        <Route path="/influencer-hub" element={<InfluencerTracker />} />
        <Route path="/auto-strategy" element={<AutoStrategy />} />
        <Route path="/repurpose" element={<ContentRepurposer />} />
        <Route path="/linkedin-repurpose" element={<ContentRepurposer />} />
        <Route path="/trending" element={<TrendingTopics />} />
        <Route path="/review-dashboard" element={<ReviewDashboard />} />
        <Route path="/scheduler" element={<SchedulerBoard />} />
        <Route path="/content-studio" element={<ContentStudio />} />
        <Route path="/content-plan" element={<ContentPlanReview />} />
        <Route path="/newsletter-subscribers" element={<NewsletterSubscribers />} />
        <Route path="/analytics" element={<AnalyticsDashboard />} />
        <Route path="/publishing" element={<PublishingHub />} />
        {/* Labs */}
        <Route path="/brainstorm" element={<BrainstormLab />} />
        <Route path="/research" element={<ResearchLab />} />
      </Routes>
      <SofiaAssistant />
    </AppLayout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrainstormProvider>
        <Router>
          <AppRoutes />
        </Router>
      </BrainstormProvider>
    </AuthProvider>
  );
}

export default App;
